const Page = ({ children, className }) => {
  return (
    <div
      className={`max-w-7xl pt-14 pl-5 lg:pl-10 pr-8 pb-20 lg:pr-20 ${className}`}
    >
      {children}
    </div>
  )
}

export default Page
